import { render, staticRenderFns } from "./LfsCheckBoxFree.vue?vue&type=template&id=62247f12&scoped=true&"
import script from "./LfsCheckBoxFree.vue?vue&type=script&lang=ts&"
export * from "./LfsCheckBoxFree.vue?vue&type=script&lang=ts&"
import style0 from "./LfsCheckBoxFree.vue?vue&type=style&index=0&id=62247f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62247f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
